import { all, fork, call, put, takeEvery } from 'redux-saga/effects'
import logger from '../../utils/logger'

import { constants } from '../modules/heroBanner'
import * as api from '../api/heroBanner'

function* getHeroBanners() {
  try {
    const payload = yield call(api.getHeroBanners)
    yield put({
      type: constants.HERO_BANNER_GET.SUCCESS,
      payload,
    })
  } catch (e) {
    const errorMessage = e.response?.data?.message || e.message || 'Erro ao carregar hero banners'

    logger.error('Erro na saga getHeroBanners:', e)

    yield put({
      type: constants.HERO_BANNER_GET.FAILED,
      message: errorMessage,
      error: e,
    })
  }
}

function* watchGetHeroBanners() {
  yield takeEvery(constants.HERO_BANNER_GET.ACTION, getHeroBanners)
}

export function* rootSaga() {
  yield all([
    fork(watchGetHeroBanners),
  ])
}
